import React from 'react';
import './SkeletonLoader.css';

function SkeletonLoader() {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-header">
        <div className="skeleton-line skeleton-title"></div>
        <div className="skeleton-line skeleton-subtitle"></div>
      </div>
      <div className="skeleton-content">
        <div className="skeleton-line skeleton-full"></div>
        <div className="skeleton-line skeleton-medium"></div>
        <div className="skeleton-line skeleton-large"></div>
        <div className="skeleton-line skeleton-small"></div>
        <div className="skeleton-line skeleton-medium"></div>
      </div>
    </div>
  );
}

export default SkeletonLoader;